export type FilterType = {
  columnName: string;
  title: string;
  relatedColumnName: string;
  filters: FilterItemType[];
};

export type FilterItemType = {
  id: string;
  key: string;
  value: number;
  checked: boolean;
  relatedColumnKey: string;
  entityId?: string;
};

export type SuggestionType = {
  columnName: string;
  value: string;
};

export enum FilterOptionEnum {
  None,
  StartsWith,
  EndsWith,
  Contains,
  DoesNotContain,
  IsEmpty,
  IsNotEmpty,
  IsGreaterThan,
  IsGreaterThanOrEqualTo,
  IsLessThan,
  IsLessThanOrEqualTo,
  IsEqualTo,
  IsNotEqualTo,
}

export enum FilterOrderEnum {
  Zero,
  Ascending,
  Descending,
}
